import dateInputToTimestamp from '../../utils/dateInputToTimestamp'

// AI-CONTEXT: See docs/pitfalls.md#state-handler-overwrites-sibling-field
// AI-CONTEXT: See docs/pitfalls.md#state-dialog-draft-outlives-its-target
//
// Welke velden een statuswissel van een deelnemer schrijft. Nodig omdat
// Personas.jsx en PersonaBuilder.jsx bij ELKE wissel alle vier de velden van
// uitstroom en inactiviteit schreven, gevuld uit het venster van een eerdere
// wissel: zo kreeg een andere deelnemer andermans uitstroomdatum en reden.

/**
 * @typedef {object} StatusDraft
 * @property {string} [reason] - De reden uit het venster
 * @property {string} [date] - De datum uit het venster, 'yyyy-mm-dd' of leeg
 */

/**
 * Alleen de velden van deze wissel. Uitstroom en inactiviteit krijgen hun reden
 * en datum; elke andere status alleen `Status`. Terug naar actief laat de oude
 * uitstroomgegevens dus staan als geschiedenis (besluit Gijs, 2026-10-15) — de
 * agenda leest de uitstroomdatum alleen bij de status 'Uitgestroomd'.
 *
 * @param {string} status - De nieuwe status
 * @param {StatusDraft} [draft] - Wat er in het venster is ingevuld
 * @returns {Record<string, any>} Het patch-object voor `Personas/{docid}`
 */
const statusChangePatch = (status, draft = {}) => {
    const reason = draft.reason || ''
    const date = dateInputToTimestamp(draft.date)
    if (status === 'outflow') return { Status: status, OutflowReason: reason, OutflowDate: date }
    if (status === 'inactive') return { Status: status, InactiveReason: reason, InactiveDate: date }
    return { Status: status }
}

export default statusChangePatch
